var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",class:[{ 'has-error':_vm.error }]},[_vm._t("default"),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"help-block validation-text"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }